import React from 'react';

import Participate from '@components/lpc/Pot/AmountModule/Participate/Participate';
import SharePot from '@components/lpc/Pot/SharePot/SharePot';
import { potType } from '@propTypes/potTypes';

import css from './ParticipantMobileBloc.module.scss';

type ParticipantMobileBlocProps = {
    pot: potType;
    setOpenParticipate: (boolean) => void;
};

const ParticipantMobileBloc = ({ pot, setOpenParticipate }: ParticipantMobileBlocProps) => {
    return (
        <>
            <div className={css.participate_bloc}>
                <div className={css.participate_bloc__flex_box}>
                    <SharePot potRef={pot.uniq} namePot={pot.title} />
                    <Participate
                        isFrozen={pot.isFrozenAccount}
                        potStatus={pot.status}
                        potRef={pot.uniq}
                        poolContribution={pot.poolContribution}
                        personRole={pot.personRole}
                        commissionType={pot.commissionType}
                        customVariant={'primary'}
                        customCta={`${css.participate_bloc__btn}`}
                        customChildren={css.participate_bloc__btn__children}
                        setOpenParticipate={(value) => setOpenParticipate(value)}
                    >
                        <img
                            className={css.participate_bloc__btn__img}
                            src="/front-static/icons/action/add-outline-white.svg"
                            alt="participate"
                        />
                    </Participate>
                </div>
            </div>
        </>
    );
};

export default ParticipantMobileBloc;
